<template>
    <div class="mx-8">
        <v-server-table
            :url="apiUrl"
            :columns="columns"
            :options="options"
            ref="table"
            @loaded="tableLoaded"
            @row-click="handleRowClick"
        >
            <template v-slot:actions="props">
                <div class="flex">
                    <button class="ml-auto text-primary" @click="openModal(props.row)">
                        <img src="/svg/list_arrow.svg" alt=">">
                    </button>
                </div>
            </template>
        </v-server-table>
        <div class="absolute top-0 left-0 flex mt-12 ml-20">
            <img
                class="pr-3"
                src="/assets/icon_search.svg"
                alt="Search"
            />
            <input
                class="h-full menu-search"
                type="text"
                placeholder="Pretražite pojam iz tablice"
                @input="searchQuery"
            />
        </div>

        <div class="absolute top-0 right-0 flex mt-12 mr-20 space-x-4">
            <div class="flex flex-col">
                <label for="start_date" class="text-sm text-gray-600">Od:</label>
                <vue-ctk-date-time-picker
                    class="form-control"
                    v-model="startDate"
                    label="Odaberite datum"
                    locale="hr"
                    format="YYYY-MM-DD"
                    formatted="DD.MM.YYYY."
                    :only-date="true"
                />
            </div>
            <div class="flex flex-col">
                <label for="end_date" class="text-sm text-gray-600">Do:</label>
                <vue-ctk-date-time-picker
                    class="form-control"
                    v-model="endDate"
                    label="Odaberite datum"
                    locale="hr"
                    format="YYYY-MM-DD"
                    formatted="DD.MM.YYYY."
                    :only-date="true"
                />
            </div>
            <button
                class="bg-blue-500 text-white px-4 py-2 rounded"
                @click="applyDateFilters"
            >
                Primijeni
            </button>
        </div>

        <OdooSyncErrorLogModal
            :visible="showModal"
            :date="selectedDate"
            @close="closeModal"
        />
    </div>
</template>

<script>
import OdooSyncErrorLogModal from './OdooSyncErrorLogModal.vue';
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";

export default {
    components: {
        OdooSyncErrorLogModal,
        VueCtkDateTimePicker
    },

    props: {
        filters: {
            type: Array,
            default: () => ([])
        },
        columns: {
            required: true,
            type: Array,
        },
        apiUrl: {
            required: true,
            type: String,
        },
        perPage: {
            required: false,
            type: Number,
            default: null,
        },
        sortColumn: {
            required: false,
            type: String,
            default: null,
        },
        sortType: {
            required: false,
            type: String,
            default: 'asc',
        },
        initialFilter: {
            type: Object,
            default: () => ({}),
        },
        dateFilterVisible: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            options: {
                texts: {
                    filterPlaceholder: 'Search',
                    limit: 'Items per page: ',
                    count: '{count} zapisa',
                    noResults: 'Ne postoje zapisi',
                    loading: 'Učitavam...',
                    first: 'Prva',
                    last: 'Zadnja',
                },
                pagination: {
                    nav: 'scroll',
                    edge: true,
                },
                perPageValues: [],
                customFilters: ['query', 'filters', 'start_date', 'end_date'],
                serverMultiSorting: true,
                resizableColumns: false,
                headings: {
                    sync_date: 'Datum',
                    total_syncs: 'Ukupno syncova',
                    success_count: 'Uspješni',
                    failure_count: 'Neuspješni',
                    actions: 'Akcije',
                },
            },
            startDate: null,
            endDate: null,
            showModal: false,
            selectedDate: "",
        };
    },

    created() {
        this.showLoader();

        window.axios.defaults.headers.Authorization = `Bearer ${window.App.user.api_token}`
        window.axios.defaults.headers.Accept = 'application/json'



        if (this.initialFilter.model) {
            this.options.initFilters = {
                role: {
                    column: this.initialFilter.column,
                    value: this.initialFilter.value
                }
            }
        }

        if (this.columns && this.columns.headings) {
            this.options.headings = this.columns.headings
        }

        if (this.perPage) {
            this.options.perPage = this.perPage
        }

        if (this.sortColumn) {
            this.options.orderBy = {
                ascending: this.sortType == 'asc' ? true : false,
                column: this.sortColumn,
            }
        }
    },

    methods: {
        applyDateFilters() {
            const parseDate = (dateString) => {
                if (!dateString) return null;

                const [year, month, day] = dateString.split('-');
                return new Date(year, month - 1, day);
            };

            const formattedStartDate = this.startDate;
            const formattedEndDate = this.endDate;

            Event.$emit('vue-tables.filter::start_date', formattedStartDate);
            Event.$emit('vue-tables.filter::end_date', formattedEndDate);
        },


        searchQuery(e) {
            Event.$emit('vue-tables.filter::query', e.target.value);
        },

        handleRowClick(event) {
            const row = event.row || {};
            this.openModal(row);
        },

        openModal(row) {
            if (row.sync_date) {
                this.selectedDate = row.sync_date;
                this.showModal = true;
            }
        },

        closeModal() {
            this.showModal = false;
        },

        tableLoaded() {
            this.hideLoader();
            let emitData = {
                loaded: true,
            };
            window.Bus.$emit('dataTableLoaded', emitData);
        },
    },
};
</script>

<style lang="scss">
</style>
